module.exports = __webpack_public_path__ + "img/Rectangle 82.a3346f29.png";